import type { IconData } from '@stacksjs/iconify-core'

export const screwdriver: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M27.24 27.822c1.027 1.168 1.064 2.816.115 4.048c-1.197 1.555-3.15 3.897-5.972 6.72s-5.166 4.776-6.72 5.973c-1.233.949-2.88.912-4.049-.116a79 79 0 0 1-3.627-3.435a79 79 0 0 1-3.436-3.628c-1.027-1.167-1.064-2.815-.116-4.048c1.198-1.554 3.15-3.897 5.973-6.72s5.166-4.776 6.72-5.973c1.233-.948 2.88-.911 4.048.116c.88.773 2.073 1.88 3.628 3.436a79 79 0 0 1 3.436 3.627\"/><path d=\"M22.044 22.475q.124-.177.282-.336l10.41-10.41l.096-3.96a2 2 0 0 1 1.08-1.727l5.905-3.06a1 1 0 0 1 1.167.18l3.853 3.853a1 1 0 0 1 .181 1.167l-3.06 5.906a2 2 0 0 1-1.727 1.08l-3.96.097l-10.41 10.41a2.5 2.5 0 0 1-.336.281\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default screwdriver
